import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../store/app.state";
import { Subscription } from "rxjs";
import { Roles } from "../../../../models/enums";
import { INews, NewsOperationType } from "src/app/models/news.model";
import { UserModel } from "src/app/models/user.model";
import { NewsEditModalComponent } from "../../news/news-edit/news-edit-modal.component";
import {
  GetNewsAction,
  GetNewsByIdAction,
} from "../../../../store/news/actions";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-news-detail-rp",
  templateUrl: "./news-detail-rp.component.html",
  styleUrls: ["./news-detail-rp.component.scss"],
})
export class NewsDetailRpComponent implements OnInit, OnDestroy {
  private newsSubscription: Subscription;
  private newsDetailsSubscription: Subscription;
  private userSubscription: Subscription;

  allNews: INews[] = [];
  news: INews[] = [];
  oneNews: INews;
  activeNewsId: string;
  isLeagueRole = false;
  currentUser: UserModel;
  currentUrl: string;
  isPublished: boolean = true;
  referrerUrl: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    protected store: Store<AppState>,
    private readonly modalService: NgbModal,
  ) {
    this.currentUrl = "";
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.activeNewsId = params["id"];
      this.store.dispatch(new GetNewsAction(this.currentUrl, true, true));
      this.changeNews();
    });

    this.userSubscription = this.store
      .select((state) => state.user.currentUser)
      .subscribe((user) => {
        if (user.role) {
          this.currentUser = user;
          this.isLeagueRole = user.role === Roles.League;
          this.isPublished =
            this.route.snapshot.queryParamMap.get("published") === "true";
        }
      });

    this.newsSubscription = this.store
      .select((state) => state.news)
      .subscribe((result) => {
        if (result && result.getLoading === false && result.allNews) {
          this.allNews = result.allNews.items;
          this.currentUrl = result.allNews?.currentUrl;
          this.changeNews();
        }
      });

    this.newsDetailsSubscription = this.store
      .select((state) => state.news)
      .subscribe(async (result) => {
        if (result && result.getLoading === false && result.detailNews) {
          this.oneNews = result.detailNews;
        }
      });
  }

  changeNews() {
    if (this.allNews) {
      if (!this.oneNews) return;
      this.news = this.allNews
        .filter((item: INews) => item.contentDate > this.oneNews.contentDate)
        .slice(-5);
    }
  }

  readClick(item: INews) {
    this.router.navigate(
      [`/news/detail/${!this.isLeagueRole ? item.id : item.entityId}`],
      {
        queryParams: { published: !this.isLeagueRole },
      },
    );
  }

  updateNewsList() {
    this.store.dispatch(new GetNewsAction(this.currentUrl));
    this.store.dispatch(new GetNewsByIdAction(this.activeNewsId, false));
  }

  editClick(event: Event, item: INews) {
    event.stopPropagation();
    const modalRef = this.modalService.open(NewsEditModalComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
      modalDialogClass: "news-edit-modal-dialog",
    });
    const instance = modalRef.componentInstance as NewsEditModalComponent;
    instance.data = {
      newsItem: item,
      user: this.currentUser,
      type: NewsOperationType.Put,
    };
    const s = instance.finishNewsEdit.subscribe((res) => {
      if (res) {
        this.updateNewsList();
        s.unsubscribe();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.newsSubscription) {
      this.newsSubscription.unsubscribe();
    }
    if (this.newsDetailsSubscription) {
      this.newsDetailsSubscription.unsubscribe();
    }
  }
}
